jQuery(function ($) {
  "use strict";

  // 同意文を開いたかどうかを保持するフラグ
  let is_read_privacy_policy = false;

  // 個人情報利用同意がチェック済みの場合、登録ボタンが活性化する
  $("#register_privacy_agreement_check").on('change', function (e) {
    const $submitBtn = $("#register_submit_btn");
    if ($("#register_privacy_agreement_check").is(':checked')
      && $submitBtn.hasClass('disabled') && is_read_privacy_policy) {
      $submitBtn.removeClass('disabled');
      $submitBtn.removeClass('register-btn-disabled');
      $submitBtn.addClass('register-btn-abled');
    } else {
      $submitBtn.addClass('disabled');
      $submitBtn.addClass('register-btn-disabled');
      $submitBtn.removeClass('register-btn-abled');
    }
  });

  // 同意文リンクを開いた際にチェック済みの場合、登録ボタンが活性化する。
  $('#register_privacy_agreement_link').on('click', function(e) {
    const $submitBtn = $("#register_submit_btn");

    is_read_privacy_policy = true;

    if ($("#register_privacy_agreement_check").prop("checked")) {
      $submitBtn.removeClass('disabled');
      $submitBtn.removeClass('register-btn-disabled');
      $submitBtn.addClass('register-btn-abled');
    }
  });

  // 非活性時に登録ボタンをクリックした場合、アラートを表示
  $('#register_submit_btn').on('click', function(e) {
    if( $(this).hasClass('disabled') ) {
        e.preventDefault();
        alert("個人情報の取り扱いをお読みいただいた上で、\n同意される場合はチェックを入れ、登録ボタンを押してください。");
    }
  });
});
